import React, { useState, useEffect } from "react";
import "../../styles/common.css";
import { randomImageEndpoint, randomImageFolderAssets } from '../../assets/data/constants';
import { BibleOfTheDay } from '../../components/bible/BibleOfThDay';
import { s } from '../../styles/pages/hotNews';

export const HotNews = () => {
    const [photo, setPhoto] = useState(null);

    useEffect(() => {
        const fetchImage = async () => {
            const mediaUrl = `${randomImageEndpoint}?folder=asset`;
            try {
                const response = await fetch(mediaUrl);
                if (response.ok) {
                    const fileName = await response.text();
                    setPhoto(`${randomImageFolderAssets}${fileName}`);
                } else {
                    console.error("Failed to fetch image");
                }
            } catch (error) {
                console.error("Error fetching the image:", error);
            }
        };

        fetchImage();
    }, []);

    return (
        <div style={s.page}>
            <BibleOfTheDay />
            {photo && (
                <img
                    width='100%'
                    src={photo}
                    alt='Hot News'
                    style={s.photo}
                />
            )}
        </div>
    );
};

